import { GROUPED_STATIC_TEXT_ROLE } from '../../../../components/ui-components/NameValueTableRow'
import { RightChevron } from '../../../../icons/questionnaire/RightChevron'

export type TaxSummaryCardProps = {
  netCapitalGains: string
  totalTaxLiability: string
  onViewWithdrawals?: () => void
  embedded?: boolean
}

export function TaxSummaryCard({
  netCapitalGains,
  totalTaxLiability,
  onViewWithdrawals,
  embedded = false
}: TaxSummaryCardProps) {
  return (
    <div
      className={
        embedded
          ? ''
          : 'mt-6 rounded-[16px] bg-white border border-[#EBF2F2]'
      }
    >
      <div
        role={GROUPED_STATIC_TEXT_ROLE}
        className='flex justify-between text-sm text-grey40 px-5 pt-4'
        aria-label={`Net realised gains, ${netCapitalGains}`}
      >
        <span aria-hidden='true'>Net realised gains</span>
        <span aria-hidden='true' className='text-sm font-medium text-[#232323]'>{netCapitalGains}</span>
      </div>
      <div
        role={GROUPED_STATIC_TEXT_ROLE}
        className='mt-4 flex justify-between text-sm text-grey40 px-5 pb-6 border-b border-[#EBF2F2]'
        aria-label={`Total tax liability, ${totalTaxLiability}`}
      >
        <span aria-hidden='true'>Total tax liability</span>
        <span aria-hidden='true' className='text-sm font-medium text-[#232323]'>{totalTaxLiability}</span>
      </div>
      {onViewWithdrawals ? (
        <button
          type='button'
          onClick={onViewWithdrawals}
          aria-description='Double tap to view withdrawal details'
          className='outline-none focus:outline-none w-full flex items-center justify-between text-left text-sm text-[#232323] p-5 cursor-pointer bg-transparent border-none'
        >
          <span>View withdrawals</span>
          <span aria-hidden className='text-[#8E9393] w-5 h-5'>
            <RightChevron />
          </span>
        </button>
      ) : (
        <div className='outline-none focus:outline-none w-full flex items-center justify-between text-left text-sm text-[#232323] p-5'>
          <span>View withdrawals</span>
          <span aria-hidden className='text-[#8E9393] w-5 h-5'>
            <RightChevron />
          </span>
        </div>
      )}
    </div>
  )
}

